import { render, staticRenderFns } from "./ExternalReferencesDropdown.vue?vue&type=template&id=55b0b473&"
import script from "./ExternalReferencesDropdown.vue?vue&type=script&lang=js&"
export * from "./ExternalReferencesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b0b473')) {
      api.createRecord('55b0b473', component.options)
    } else {
      api.reload('55b0b473', component.options)
    }
    module.hot.accept("./ExternalReferencesDropdown.vue?vue&type=template&id=55b0b473&", function () {
      api.rerender('55b0b473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ExternalReferencesDropdown.vue"
export default component.exports